<div class="cp-container">
  <div class="cp-card">

    <!-- Invalid/expired token -->
    <ng-container *ngIf="isInvalidToken && !success">
      <div class="cp-icon cp-icon-error">
        <i-tabler name="alert-triangle" style="width:28px;height:28px;"></i-tabler>
      </div>
      <h2 class="cp-title">Invalid Reset Link</h2>
      <p class="cp-desc">
        This password reset link is invalid or has expired.
        Please request a new one from the login page.
      </p>
      <button class="cp-btn" (click)="goToLogin()">
        <i-tabler name="arrow-left" style="width:14px;height:14px;"></i-tabler>
        Back to Sign In
      </button>
    </ng-container>

    <!-- Success state -->
    <ng-container *ngIf="success">
      <div class="cp-icon cp-icon-success">
        <i-tabler name="circle-check" style="width:28px;height:28px;"></i-tabler>
      </div>
      <h2 class="cp-title">Password Updated</h2>
      <p class="cp-desc">
        Your password has been reset successfully.
        You can now sign in with your new password.
      </p>
      <button class="cp-btn" (click)="goToLogin()">
        Sign In
        <i-tabler name="arrow-right" style="width:14px;height:14px;"></i-tabler>
      </button>
    </ng-container>

    <!-- Reset form -->
    <ng-container *ngIf="!isInvalidToken && !success">
      <div class="cp-icon">
        <i-tabler name="lock" style="width:28px;height:28px;"></i-tabler>
      </div>
      <h2 class="cp-title">Set New Password</h2>
      <p class="cp-desc">
        Create a new password for <strong>{{ email }}</strong>
      </p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="cp-form">

        <div class="cp-field">
          <label class="cp-label">New Password</label>
          <div class="cp-input-wrap">
            <input [type]="showPassword ? 'text' : 'password'" class="cp-input" formControlName="password"
              placeholder="Create a strong password" />
            <button type="button" class="cp-eye" (click)="showPassword = !showPassword">
              <i-tabler [name]="showPassword ? 'eye-off' : 'eye'" style="width:16px;height:16px;"></i-tabler>
            </button>
          </div>
          <div class="cp-field-error"
            *ngIf="form.get('password')?.touched && form.get('password')?.hasError('required')">
            Password is required
          </div>

          <!-- Password strength rules -->
          <div class="pw-rules" *ngIf="showPasswordRules">
            <div *ngFor="let rule of passwordRules" class="pw-rule" [class.met]="rule.met">
              <i-tabler [name]="rule.met ? 'circle-check-filled' : 'circle'" style="width:14px;height:14px;"></i-tabler>
              <span>{{ rule.label }}</span>
            </div>
          </div>
        </div>

        <div class="cp-field">
          <label class="cp-label">Confirm Password</label>
          <div class="cp-input-wrap">
            <input [type]="showConfirmPassword ? 'text' : 'password'" class="cp-input" formControlName="confirmPassword"
              placeholder="Re-enter your password" />
            <button type="button" class="cp-eye" (click)="showConfirmPassword = !showConfirmPassword">
              <i-tabler [name]="showConfirmPassword ? 'eye-off' : 'eye'" style="width:16px;height:16px;"></i-tabler>
            </button>
          </div>
          <div class="cp-field-error" *ngIf="form.get('confirmPassword')?.touched && form.errors?.['mismatch']">
            Passwords do not match
          </div>
        </div>

        <div class="cp-error" *ngIf="errorMsg">
          <i-tabler name="alert-circle" style="width:14px;height:14px;"></i-tabler>
          {{ errorMsg }}
        </div>

        <button type="submit" class="cp-btn" [disabled]="form.invalid || loading">
          <span *ngIf="!loading">Update Password</span>
          <span *ngIf="loading" class="cp-loading">
            <mat-spinner diameter="18" class="cp-spinner"></mat-spinner>
            Updating...
          </span>
        </button>
      </form>

      <button class="cp-back" (click)="goToLogin()">
        <i-tabler name="arrow-left" style="width:14px;height:14px;"></i-tabler>
        Back to sign in
      </button>
    </ng-container>

  </div>
</div>